import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scoreNumber'
})
export class ScoreNumberPipe implements PipeTransform {


  transform(value: number): string {
    let str = "";
    if (value > 10000000) {
      str += (value / 1000000).toFixed(2) + "M";

    } else if (value > 10000) {
      str += (value / 1000).toFixed(1) + "K";
    } else {
      return formatNumber(value, "en-US", "1.0")
    }
    return str;
  }

}
